import _0 from "./assets/img/home/events/1.jpg";
import _1 from "./assets/img/home/events/2.jpg";
import _2 from "./assets/img/home/events/3.jpg";
import _3 from "./assets/img/home/events/4.jpg";
import _4 from "./assets/img/home/events/5.jpg";
import _5 from "./assets/img/home/naturalism/1.jpg";
import _6 from "./assets/img/home/naturalism/2.jpg";
import _7 from "./assets/img/home/naturalism/3.jpg";
import _8 from "./assets/img/home/naturalism/4.jpg";
import _9 from "./assets/img/home/naturalism/5.jpg";
import _10 from "./assets/img/home/portraits/1.jpg";
import _11 from "./assets/img/home/portraits/2.jpg";
import _12 from "./assets/img/home/portraits/3.jpg";
import _13 from "./assets/img/home/portraits/4.jpg";
import _14 from "./assets/img/home/portraits/5.jpg";
import _15 from "./assets/img/home/reportages/1.jpg";
import _16 from "./assets/img/home/reportages/2.jpg";
import _17 from "./assets/img/home/reportages/3.jpg";
import _18 from "./assets/img/home/reportages/4.jpg";
import _19 from "./assets/img/home/reportages/5.jpg";
import _20 from "./assets/img/home/urban/1.jpg";
import _21 from "./assets/img/home/urban/2.jpg";
import _22 from "./assets/img/home/urban/3.jpg";
import _23 from "./assets/img/home/urban/4.jpg";
import _24 from "./assets/img/home/urban/5.jpg";


export const files = {

 "directories": {


				"events": {
				"files": {

                        "1": {
					        "url": _0,
					        "name": "1"
                        }
				    ,

                        "2": {
					        "url": _1,
					        "name": "2"
                        }
				    ,

                        "3": {
					        "url": _2,
					        "name": "3"
                        }
				    ,

                        "4": {
					        "url": _3,
					        "name": "4"
                        }
				    ,

                        "5": {
					        "url": _4,
					        "name": "5"
                        }
				    ,
}
,

				},

			

				"naturalism": {
				"files": {

                        "1": {
					        "url": _5,
					        "name": "1"
                        }
				    ,

                        "2": {
					        "url": _6,
					        "name": "2"
                        }
				    ,

                        "3": {
					        "url": _7,
					        "name": "3"
                        }
				    ,

                        "4": {
					        "url": _8,
					        "name": "4"
                        }
				    ,

                        "5": {
					        "url": _9,
					        "name": "5"
                        }
				    ,
}
,

				},

			

				"portraits": {
				"files": {

                        "1": {
					        "url": _10,
					        "name": "1"
                        }
				    ,

                        "2": {
					        "url": _11,
					        "name": "2"
                        }
				    ,

                        "3": {
					        "url": _12,
					        "name": "3"
                        }
				    ,

                        "4": {
					        "url": _13,
					        "name": "4"
                        }
				    ,

                        "5": {
					        "url": _14,
					        "name": "5"
                        }
				    ,
}
,

				},

			

				"reportages": {
				"files": {

                        "1": {
					        "url": _15,
					        "name": "1"
                        }
				    ,

                        "2": {
					        "url": _16,
					        "name": "2"
                        }
				    ,

                        "3": {
					        "url": _17,
					        "name": "3"
                        }
				    ,

                        "4": {
					        "url": _18,
					        "name": "4"
                        }
				    ,

                        "5": {
					        "url": _19,
					        "name": "5"
                        }
				    ,
}
,

				},

			

				"urban": {
				"files": {

                        "1": {
					        "url": _20,
					        "name": "1"
                        }
				    ,

                        "2": {
					        "url": _21,
					        "name": "2"
                        }
				    ,

                        "3": {
					        "url": _22,
					        "name": "3"
                        }
				    ,

                        "4": {
					        "url": _23,
					        "name": "4"
                        }
				    ,

                        "5": {
					        "url": _24,
					        "name": "5"
                        }
				    ,
}
,

				},

			},
};